import * as Joi from 'joi';

const stringWithNumbersOnlyRegEx = /^\d+$/; // @ref https://github.com/sideway/joi/issues/1157#issuecomment-293538673

export const IncorporatorSchema = Joi.object()
  .keys({
    firstName: Joi.string().trim().min(1).max(100).required().messages({
      'any.required': 'First name is required.',
      'string.base': 'First name is invalid.',
      'string.empty': 'First name is invalid.',
      'string.min': 'First name must have at most 100 characters only.',
      'string.max': 'First name must have at most 100 characters only.',
    }),
    middleName: Joi.string().trim().min(1).max(100).optional().messages({
      'string.base': 'Middle name is invalid.',
      'string.empty': 'Middle name is invalid.',
      'string.min': 'Middle name must have at most 100 characters only.',
      'string.max': 'Middle name must have at most 100 characters only.',
    }),
    hasMiddleName: Joi.boolean().required().messages({
      'any.required': 'Field is required.',
      'boolean.base': 'Field is invalid.',
    }),
    lastName: Joi.string().trim().min(1).max(100).required().messages({
      'any.required': 'Last name is required.',
      'string.base': 'Last name is invalid.',
      'string.empty': 'Last name is invalid.',
      'string.min': 'Last name must have at most 100 characters only.',
      'string.max': 'Last name must have at most 100 characters only.',
    }),
    bldgNameNo: Joi.string()
      .trim()
      .min(1)
      .max(200)
      .optional()
      .allow('')
      .messages({
        'string.base': 'Building name and number is invalid.',
        'string.empty': 'Building name and number is invalid.',
        'string.min':
          'Building name and number can be at most 200 characters only.',
        'string.max':
          'Building name and number can be at most 200 characters only.',
      }),
    emailAddress: Joi.string().trim().min(1).max(100).required().messages({
      'any.required': 'Email address is required.',
      'string.base': 'Email address is invalid.',
      'string.empty': 'Email address is invalid.',
      'string.min': 'Email address must have at most 100 characters only.',
      'string.max': 'Email address must have at most 100 characters only.',
    }),
    contactNumber: Joi.string()
      .trim()
      .min(1)
      .max(30)
      .regex(stringWithNumbersOnlyRegEx)
      .required()
      .messages({
        'any.required': 'Contact number is required.',
        'string.base': 'Contact number is invalid.',
        'string.empty': 'Contact number is invalid.',
        'string.pattern.base': 'Contact number is invalid.',
        'string.min': 'Contact number must have at most 30 characters only.',
        'string.max': 'Contact number must have at most 30 characters only.',
      }),
    birthDate: Joi.date().required().messages({
      'date.base': 'Birthdate is invalid.',
    }),
    residentialAddress: Joi.string().trim().min(1).max(64).required().messages({
      'any.required': 'Address is required.',
      'string.base': 'Address is invalid.',
      'string.empty': 'Address is invalid.',
      'string.min': 'Address must have at most 64 characters only.',
      'string.max': 'Address must have at most 64 characters only.',
    }),
    barangay: Joi.string().trim().min(1).max(200).required().messages({
      'any.required': 'Barangay is required.',
      'string.base': 'Barangay is invalid.',
      'string.empty': 'Barangay is invalid.',
      'string.min': 'Barangay must have at most 200 characters only.',
      'string.max': 'Barangay must have at most 200 characters only.',
    }),
    city: Joi.string().trim().min(1).max(100).required().messages({
      'any.required': 'City is required.',
      'string.base': 'City is invalid.',
      'string.empty': 'City is invalid.',
      'string.min': 'City must have at most 100 characters only.',
      'string.max': 'City must have at most 100 characters only.',
    }),
    province: Joi.string().trim().min(1).max(64).required().messages({
      'any.required': 'State is required.',
      'string.base': 'State is invalid.',
      'string.empty': 'State is invalid.',
      'string.min': 'State must have at most 64 characters only.',
      'string.max': 'State must have at most 64 characters only.',
    }),
    postalCode: Joi.string()
      .trim()
      .min(4)
      .max(10)
      .regex(stringWithNumbersOnlyRegEx)
      .required()
      .messages({
        'any.required': 'Postal code is required.',
        'string.base': 'Postal code is invalid.',
        'string.empty': 'Postal code is invalid.',
        'string.min': 'Postal code must have 4 to 10 characters only.',
        'string.max': 'Postal code must have 4 to 10 characters only.',
        'string.pattern.base': 'Postal code is invalid.',
      }),
  })
  .messages({
    'object.base': 'incorporators must contain objects.',
  });
